// Falls back to /api/v1 for production when running on Azure Static Web Apps
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api/v1';

/**
 * Fetches the survey questions for a given QR token.
 * 
 * @param {string} qrToken The token extracted from the URL
 * @returns {Promise<Object>} The API response envelope (success or error)
 */
export const fetchSurveyForm = async (qrToken) => {
  if (!qrToken) {
    return {
      error: {
        code: '400 MISSING_TOKEN',
        message: 'No QR token provided in the URL.'
      }
    };
  }

  try {
    const response = await fetch(`${API_BASE_URL}/feedback/form/${qrToken}`);
    const data = await response.json();
    
    // TEMPORARY FALLBACK: Inject program metadata until backend implements it
    // The user requested to get this from a local file and use the .ico in public folder
    if (data && !data.program) {
      data.program = {
        title: "SSEHV Feedback Program",
        description: "Please share your thoughts on the recent program.",
        logo: "/favicon.ico"
      };
    }
    
    return data;
  } catch (err) {
    console.error('API Network Error:', err);
    return {
      error: {
        code: '500 NETWORK_ERROR',
        message: 'Could not connect to the server.'
      }
    };
  }
};

/**
 * Submits the transformed feedback payload to the backend.
 * 
 * @param {Object} payload The transformed payload { qr_token, responses }
 * @returns {Promise<Object>} The API response envelope (success or error)
 */
export const submitFeedback = async (payload) => {
  try {
    const response = await fetch(`${API_BASE_URL}/feedback/submit`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    const data = await response.json();
    return data;
  } catch (err) {
    console.error('API Network Error on Submit:', err);
    return {
      error: {
        code: '500 NETWORK_ERROR',
        message: 'Could not submit feedback due to a network error.'
      }
    };
  }
};
